import type { BadgeProps } from '@shopify/polaris';

import { Badge, Text } from '@shopify/polaris';
import { GTooltip } from '~/presentation/ui';
import { cls } from '~/utils';

interface AssetTemplateBadgeProps {
  show?: boolean;
  tone: BadgeProps['tone'];
  label: string;
  tooltip?: string;
  truncate?: boolean;
}
export const AssetTemplateBadge: React.FC<AssetTemplateBadgeProps> = (props) => {
  const { show = true, tone, label, tooltip, truncate } = props;
  if (!show) return null;

  if (!tooltip) {
    return (
      <span className="shrink-0 whitespace-nowrap">
        <Badge tone={tone}>{label}</Badge>
      </span>
    );
  }

  return (
    <div
      className={cls('shrink-0 whitespace-nowrap min-w-[80px]', {
        'overflow-hidden': truncate,
      })}
    >
      <GTooltip activatorWrapper="tooltip-content" content={tooltip}>
        <Text as="p" variant="bodySm" fontWeight="semibold" truncate={truncate}>
          <Badge tone={tone}>{label}</Badge>
        </Text>
      </GTooltip>
    </div>
  );
};
